import { Card, Row, Col, Typography, Radio, Upload, message, Button, Timeline } from "antd";
import Echat from "components/charts/Echat";
import LineChart from "components/charts/LineChart";
import React, { useState } from "react";
import { count, list } from "utils/HomeData";
import { Iconify } from "utils/Iconify";
import AntCard from "components/AntCard";
import card from "../assets/images/info-card-1.jpg";
import { timelineList } from "utils/HomeData";
import { Link } from "react-router-dom";
import { useAuth } from "../AuthContext";
const { Title, Paragraph, Text } = Typography;
export default function Home() {
  const [reverse, setReverse] = useState(false);
  const { user } = useAuth();
  const apps = user?.TenantApps || ["indigent", "lending", "leads"];
  const onChange = (e) => console.log(`radio checked:${e.target.value}`);
  const uploadProps = {
    name: "file",
    action: "https://www.mocky.io/v2/5cc8019d300000980a055e76",
    headers: {
      authorization: "authorization-text",
    },
    onChange(info) {
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed`);
      }
    },
  };
  return (
    <>
      <div className="layout-content">
        <Row gutter={[24, 0]}>
          <AntCard xl={10}>
            <Echat />
          </AntCard>
          <AntCard xl={14}>
            <LineChart />
          </AntCard>
        </Row>
        <Row gutter={[24, 24]} style={{ marginTop: 24 }}>
          {apps.includes("leads") && (
            <Col xs={24} md={12} lg={8}>
              <Card title="Lead Intake" bordered={false}>
                <p>Capture leads from web, email, or Excel imports.</p>
                <Link to="/leads"><Button type="primary">Go to Leads</Button></Link>
                <Link to="/lead-inbox" style={{ marginLeft: 8 }}><Button>Lead Inbox</Button></Link>
              </Card>
            </Col>
          )}
          {apps.includes("leads") && (
            <Col xs={24} md={12} lg={8}>
              <Card title="Bookings" bordered={false}>
                <p>Manage bookings, reminders, and calendar scheduling.</p>
                <Link to="/bookings"><Button type="primary">View Bookings</Button></Link>
              </Card>
            </Col>
          )}
          {apps.includes("leads") && (
            <Col xs={24} md={12} lg={8}>
              <Card title="Invoicing & Reports" bordered={false}>
                <p>Generate quotations, issue invoices, and view reports.</p>
                <Link to="/invoices"><Button type="primary">Invoices</Button></Link>
                <Link to="/reports" style={{ marginLeft: 8 }}><Button>Reports</Button></Link>
              </Card>
            </Col>
          )}
          {apps.includes("indigent") && (
            <Col xs={24} md={12} lg={8}>
              <Card title="Indigent Management" bordered={false}>
                <p>Verify identity, manage indigent records, and track approvals.</p>
                <Link to="/search"><Button type="primary">Verification</Button></Link>
                <Link to="/tables" style={{ marginLeft: 8 }}><Button>Records</Button></Link>
              </Card>
            </Col>
          )}
          {apps.includes("lending") && (
            <Col xs={24} md={12} lg={8}>
              <Card title="Micro-Lending" bordered={false}>
                <p>Manage micro-lending applications and approvals.</p>
                <Link to="/apply"><Button type="primary">Applications</Button></Link>
              </Card>
            </Col>
          )}
        </Row>
      </div>
    </>
  );
}
